import React from 'react'
import PaletteCell from './PaletteCell'
import { FaTrashAlt } from 'react-icons/fa'
import { HiOutlineRefresh } from 'react-icons/hi'
import { Link } from 'react-router-dom'

const Palette = ({palette, setPalettes, id, setPalette, setSuggest, setMain, setButtonState}) => {
  const handleDelete = () => {
    let palettes = JSON.parse(localStorage.getItem("palette"))
    palettes = palettes.filter((eachPalette, index) => {
        return index !== id
    })
    localStorage.setItem("palette", JSON.stringify(palettes))
    setPalettes(palettes)
  }
  
  const handleLoad = () => {
    setMain(palette[0])
    palette.shift()
    setPalette(palette)
    setSuggest(true)
    setButtonState("Clear")
  }

  return (
    <div className='palette-container'>
        <div className='palette-colors-container'>
          {palette.map((color, id) => (<PaletteCell color={color} key={id + Math.random()}/>))}
        </div>
        <div className='container-actions'>
          <FaTrashAlt onClick={handleDelete} style={{cursor: "pointer"}}/>
          <Link to='/color-palette' className='load-link'><HiOutlineRefresh onClick={handleLoad}/></Link>
        </div>
    </div>
  )
}

export default Palette